import React, { useState } from 'react';
import { Button, Divider, Modal, Typography } from 'antd';
import { IArchiveChatPayload, IGenAISearchHistory } from '../../../../../libs/models/GenAIModels';
import { GenAIAction } from '../../../../../libs/store/actions/GenAIActions';

interface IChatSessionOptionsProps {
  session: IGenAISearchHistory;
  archiveChat: (payload: IArchiveChatPayload) => GenAIAction;
  hidePopover: () => void;
}

const ChatSessionOptions: React.FC<IChatSessionOptionsProps> = ({
  session,
  archiveChat,
  hidePopover,
}) => {
  const { sessionId, sessionName, userId, archived } = session;
  const [modalVisible, setModalVisible] = useState(false);
  const handleArchive = () => {
    hidePopover();
    archiveChat({ sessionId, userId, isArchived: !archived });
  };

  const handleDelete = () => {
    archiveChat({ sessionId, userId, isDeleted: true });
    setModalVisible(false);
  };

  const openModal = () => {
    hidePopover();
    setModalVisible(true);
  };

  return (
    <div className="dropdown-popup">
      <span onClick={handleArchive}>{archived ? 'Unarchive' : 'Archive'}</span>
      <Divider />
      <span onClick={openModal}>{'Delete'}</span>
      <Modal className="custom-modal" open={modalVisible} footer={null} closable={false}>
        <Typography className="delete-modal-title">{'Delete chat ?'}</Typography>
        <Typography className="delete-modal-content">
          {'Are you sure you want to delete '}
          <strong>{`"${sessionName}"`}</strong>
        </Typography>
        <div key="buttons" className="button-container">
          <Button key="cancel" onClick={() => setModalVisible(false)} className="cancel-button">
            {'Cancel'}
          </Button>
          <Button key="delete" type="primary" onClick={handleDelete} className="delete-button">
            {'Delete'}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ChatSessionOptions;
